import React from "react";
import NavPublicUser from "../navbarPublicUser"
import PubBagBody from "../PubBagBody"
import Footer from "../Footer";

export default function PubBag(){

    return(
        <div>
            <NavPublicUser />
            <PubBagBody />
            <Footer /> 
        </div>
      

    )


}